// PlanningFilters.jsx
import React, { useState, useEffect } from 'react';
import api from '../api/client';

const PlanningFilters = ({ onFilterChange }) => {
  const [brands, setBrands] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  // 08.09.2026: раздел Calculations убран — показывается только Plan to Produce (Demand Fact/Plan выведены из UI)
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    api
      .get(`/api/planning-brands`)
      .then((response) => {
        const fetchedBrands = response.data.map((brand) => ({
          id: brand.brandID,
          name: brand.brandName,
        }));
        setBrands(fetchedBrands);
        setSelectedBrands(fetchedBrands.map((brand) => brand.name));
      })
      .catch((error) => console.error('Error fetching brands:', error));
  }, []);

  const handleApply = () => {
    onFilterChange({ selectedBrands, selectedCalculations: ['Plan to Produce'] });
    setIsOpen(false);
  };

  const handleReset = () => {
    setSelectedBrands(brands.map((brand) => brand.name));
  };

  const toggleBrand = (brandName) => {
    setSelectedBrands((prev) =>
      prev.includes(brandName)
        ? prev.filter((b) => b !== brandName)
        : [...prev, brandName]
    );
  };

  return (
    <div className="planning-filters">
      <button
        className="btn btn__white_g"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="planning-filter-icon">
          <svg className="filter__icon" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <use xlinkHref="#filter"></use>
          </svg>
        </span>
        Filters
      </button>
      {isOpen && (
        <div className="planning-filters-dropdown">
          <button
            className="planning-filters-close"
            onClick={() => setIsOpen(false)}
          >
            ×
          </button>
          <div className="planning-filters-section">
            <h4>Brands</h4>
            {brands.map((brand) => (
              <label key={brand.id} className="checkbox">
                <input
                  type="checkbox"
                  className="checkbox__real"
                  checked={selectedBrands.includes(brand.name)}
                  onChange={() => toggleBrand(brand.name)}
                />
                <span className="checkbox__fake"></span>
                <span className="checkbox__title">{brand.name}</span>
              </label>
            ))}
          </div>
          <div className="planning-filters-actions">
            <button className="btn btn__green" onClick={handleApply}>
              Apply
            </button>
            <button className="btn btn__white_g" onClick={handleReset}>
              Reset
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlanningFilters;